import {useTimer} from "./useTimer";

export default {
	useTimer
}